import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans de gestion de l'affichage chargés à la demande (spec 015).
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const DiffusionPage = page(() => import('./DiffusionPage.js'), 'DiffusionPage');
const PlanningPage = page(() => import('./PlanningPage.js'), 'PlanningPage');
const UrgencePage = page(() => import('./UrgencePage.js'), 'UrgencePage');
const EcransPage = page(() => import('./EcransPage.js'), 'EcransPage');
const SupervisionPage = page(() => import('./SupervisionPage.js'), 'SupervisionPage');

/** Routes du module Affichage (module.json `navigation`) ; le client plein écran est `/ecran`. */
export const affichageWeb: ModuleWeb = {
  module: 'affichage',
  routes: [
    { path: '/affichage', element: <DiffusionPage /> },
    { path: '/affichage/planning', element: <PlanningPage /> },
    { path: '/affichage/urgence', element: <UrgencePage /> },
    { path: '/affichage/ecrans', element: <EcransPage /> },
    { path: '/affichage/supervision', element: <SupervisionPage /> },
  ],
};
